import React from 'react'
import {Icon} from '@chakra-ui/react'

const SuccessIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" data-testid="success-icon" cursor="pointer" {...props}>
            <circle cx="12" cy="12" r="12" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.94 
            6.12243C19.2203 6.32848 19.2805 6.72274 19.0744 7.00303L11.0609
             17.9036C10.9521 18.0516 10.7841 18.1447 10.601 18.1586C10.417918.1725 
             10.2378 18.1058 10.1079 17.9759L4.98137 12.8494C4.73538 12.6034 4.73538 
             12.2046 4.98137 11.9586C5.22736 11.7126 5.62618 11.7126 5.87217 11.9586L10.4802 
             16.5666L18.0594 6.25684C18.2655 5.97655 18.6597 5.91637 18.946.12243Z"
                fill="white"
            />
        </Icon>
    )
}

export default SuccessIcon
